var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCve({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 79",
    width: 193,
    height: 79,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "253690-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #a3a5a6 } \n\t\t.s0:hover { fill: #272b3 }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m184.3 3.1v17h-48.4l-24 56h-28.7l-24-56h-33.5v39h33.5v17h-38l-12.7-13.7v-50.1l12.7-9.2h50.3l26 56.7 26.1-56.7zm-31.4 56h31.4v17h-48.4v-45h39.5v17h-22.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCve);
export default __webpack_public_path__ + "static/media/cve.5f028a3ff931dbeec327cf61954ffee0.svg";
export { ForwardRef as ReactComponent };